import { render, staticRenderFns } from "./eventosinscripcion.vue?vue&type=template&id=4bfbfe78&scoped=true&"
import script from "./eventosinscripcion.vue?vue&type=script&lang=js&"
export * from "./eventosinscripcion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bfbfe78",
  null
  
)

export default component.exports